"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colors = require("@mui/material/colors");
var _styles = require("@mui/material/styles");
// A custom theme for this app
var theme = (0, _styles.createTheme)({
  palette: {
    primary: {
      main: "#556cd6"
    },
    secondary: {
      main: "#19857b"
    },
    error: {
      main: _colors.red.A400
    }
  },
  root: {
    nav: {
      display: "inline"
    }
  },
  components: {
    MuiLink: {
      variants: [{
        props: {
          variant: "pointer"
        },
        style: {
          cursor: "pointer",
          color: "inherit"
        }
      }]
    },
    MuiCircularProgress: {
      variants: [{
        props: {
          variant: "centered"
        },
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }]
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          flex: "0 0 auto"
        }
      }
    },
    MuiButton: {
      variants: [{
        props: {
          variant: "dashed"
        },
        style: {
          textTransform: "none",
          border: "2px dashed ".concat(_colors.blue[500])
        }
      }, {
        props: {
          variant: "dashed",
          color: "secondary"
        },
        style: {
          border: "4px dashed ".concat(_colors.red[500])
        }
      }]
    }
  }
});
var _default = exports.default = theme;